<template>
  <div class="menu ">
    <carousel :perPage="1" :navigateTo="[currentPage, animated]" @page-change="changedPage">
      <slide class="has-navbar-fixed-bottom" v-for="episode in episodes" :key="episode.id">
        <h1 class="title is-4">{{episodeTitle(episode.id)}} - {{episode.title}}</h1>
        <ul class="padding menu-list">
          <li v-for="chapter in episode.chapters" :key="chapter.id">
            <div class="menu-label">{{chapterTitle(chapter.id)}}</div>
            <ul class="menu-list">
              <li v-for="(story, key) in chapter.titles" :key="key">
                <router-link :to="'/story/' + episode.id + '/' + chapter.id + '/' + key">{{story}}</router-link>
              </li>
            </ul>
          </li>
        </ul>
      </slide>
    </carousel>
    <nav class="navbar is-shadowless is-transparent is-fixed-bottom" role="navigation" aria-label="main navigation">
      <div class="navbar-menu is-shadowless is-active" style="display: flex;">
      </div>
    </nav>
  </div>
</template>

<script>
export default {

  name: 'Menu',

  data () {
    return {
      episodes: this.$root.config.episodes,
      animated: false
    }
  },
  props: {
    page: String
  },
  methods: {
    episodeTitle (id) {
      var num
      if (id === 1) {
        num = 'I'
      } else if (id === 2) {
        num = 'II'
      } else if (id === 3) {
        num = 'III'
      } else if (id === 4) {
        num = 'IV'
      } else if (id === 5) {
        num = 'Five'
      }
      return 'Episode ' + num
    },
    chapterTitle (id) {
      var num
      if (id === 1) {
        num = 'One'
      } else if (id === 2) {
        num = 'Two'
      } else if (id === 3) {
        num = 'Three'
      } else if (id === 4) {
        num = 'Four'
      } else if (id === 5) {
        num = 'Five'
      }
      return 'Chapter ' + num
    },
    changedPage (e) {
      if (this.animated === false) {
        this.animated = true
      }
      var newPage = parseInt(e) + 1
      this.$router.replace('/contents/' + newPage)
    }
  },
  computed: {
    currentPage () {
      var page
      if (!this.page) {
        page = 1
      } else {
        page = this.page
      }
      return [page - 1]
    }
  }
}
</script>

<style lang="css" scoped>
.VueCarousel-slide {
  border: none;
  text-align: left;
  font-family: inherit;
}
.title {
  text-align: center;
  margin-top: 1rem;
}
</style>
